import { getCustomEmojiIndex } from '@/logic/emoji/customEmojis'

let cachedEmojiData = null
let loadingPromise = null

export async function loadEmojiData() {
  if (cachedEmojiData) {
    return cachedEmojiData
  }
  if (loadingPromise) {
    return loadingPromise
  }

  // Keep emoji-mart data in a separate async chunk
  loadingPromise = import(/* webpackChunkName: "emoji-mart-data" */ '@emoji-mart/data')
    .then((mod) => {
      const baseData = mod?.default ?? mod
      const customIndex = getCustomEmojiIndex()
      // Merge custom emojis into the data structure that EmojiDropdown/Editor use
      cachedEmojiData = {
        ...baseData,
        emojis: {
          ...(baseData?.emojis || {}),
          ...customIndex,
        },
      }
      return cachedEmojiData
    })
    .finally(() => {
      loadingPromise = null
    })

  return loadingPromise
}
